import { render, staticRenderFns } from "./ModalConfirmOnProcess.vue?vue&type=template&id=0704700c&scoped=true&"
import script from "./ModalConfirmOnProcess.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmOnProcess.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmOnProcess.vue?vue&type=style&index=0&id=0704700c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704700c",
  null
  
)

export default component.exports